import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Field, Input, Spinner, Title3 } from "@fluentui/react-components";
import { api } from "../api/client";
import { TicketTable } from "../components/TicketTable";
import { useMe } from "../api/hooks";
import type { Ticket } from "../types/models";

export function SearchPage() {
  const [q, setQ] = useState("");
  const me = useMe();
  const isAgentLike = me.data?.user.role === "Admin" || me.data?.user.role === "Agent";
  const query = useQuery({
    queryKey: ["search", q],
    queryFn: () => api.get<{ tickets: Ticket[] }>(`/api/search?q=${encodeURIComponent(q)}`),
    enabled: q.trim().length > 0,
  });

  return (
    <div>
      <Title3>Search</Title3>
      <Field label="Find tickets by number, title, requester, category" style={{ maxWidth: 520, marginTop: 12 }}>
        <Input value={q} onChange={(_, d) => setQ(d.value)} placeholder="e.g. IT-42, password reset, john@contoso.com" />
      </Field>
      <div style={{ marginTop: 16 }}>
        {!q.trim() ? <p>Type something to search.</p>
          : query.isLoading ? <Spinner />
          : <TicketTable tickets={query.data?.tickets ?? []} showRequester editable={isAgentLike} />}
      </div>
    </div>
  );
}
